var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 .04c6.524 0 11.633 6.887 11.847 7.18.204.279.204.656 0 .935-.214.293-5.323 7.18-11.847 7.18-6.525 0-11.634-6.887-11.848-7.18-.203-.279-.203-.656 0-.935C.366 6.927 5.475.04 12 .04zm0 1.582c-4.816 0-8.97 4.569-10.2 6.065C3.03 9.182 7.193 13.753 12 13.753c4.816 0 8.97-4.57 10.2-6.065-1.232-1.495-5.394-6.066-10.2-6.066zm0 1.318c2.617 0 4.747 2.13 4.747 4.747 0 2.618-2.13 4.748-4.747 4.748-2.618 0-4.747-2.13-4.747-4.748C7.253 5.07 9.383 2.94 12 2.94zm0 1.583c-1.745 0-3.165 1.42-3.165 3.165s1.42 3.164 3.165 3.164 3.165-1.42 3.165-3.165S13.745 4.524 12 4.524z",
    transform: "translate(-526 -105) translate(106 94) translate(0 6) translate(420 5)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.065d516c8860b75390317b5f9adf1ef2.svg";
export { ForwardRef as ReactComponent };